import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import marked from "marked";
import URI from "URI/URI";
import moment from "moment";

"use strict";
ko.bindingHandlers.related = {
    init: function (elt, va, bindings, model) {
        var unique_id = ko.unwrap(va()),
            related_action = ko.unwrap(bindings().related_action);
        if (unique_id && related_action) {
            $(elt).css({
                "cursor": "pointer"
            }).bind("tap click", function (ev, ui) {
                if (ev.target && (ev.target.tagName == "A" || (ev.target.parentElement && ev.target.parentElement.tagName == "A"))) {
                    return;
                }
                ev.preventDefault();
                var entity = unique_id.split("#");
                uly.api.start().follow_with_cache("uly:data").follow("find", {
                    "rel": entity[0] + "/" + entity[1]
                }).done(function (data) {
                    uly.actions[related_action](ev, $(elt), ui, data);
                });
            });
        }
    }
};

ko.bindingHandlers.journal = {
    init: function (elt, va, bindings, model, context) {
        var text = ko.unwrap(va());
        var dom = $.parseHTML(text);
        var $parent = $(elt).parent();
        for (var i in dom) {
            var name_node = $parent.find(".name");
            if (!name_node)
                name_node = $("<div></div>").addClass("name").appendTo($parent);
            var node = dom[i];
            if (node && node.is_dom()) {
                var $node = $(node);
                if ($node.hasClass("title") || $node.hasClass("sender")) {
                    $node.hasClass("sender") ?
                        name_node.prepend(
                            $node.addClass("pull-left ").css({
                                "font-weight": "bolder",
                                "min-width": "60%"
                            }).prepend(
                                $parent.find(".fa:not(.fa-clock-o)").css({
                                    "margin-right": "2px"
                                })
                            )
                        ) :
                        name_node.append($node);
                } else
                    $(elt).append($node);
            } else if (node) {
                $(elt).append(node.nodeValue);
            }
        }
    }
};

ko.bindingHandlers.titlecol = {
    "update": function (elt, va) {
        var $elt = $(elt);
        var col = ko.unwrap(va());
        if (col && col != "") {
            $elt.css("border-top", "1px solid " + (/#/.test(col) ? col : "#" + col));
            $elt.css("border-radius", "2px");
        } else {
            $elt.css("border-top", null);
            $elt.css("border-radius", null);
        }
    }
};
/*
ko.bindingHandlers.disable = {
    init:function(elt, va, bindings, model, context) {
        $(elt).find('*').andSelf().each(function(){
            $(this).attr({"disabled":"disabled"});
        });
        ko.applyBindingsToDescendants(context, elt);
        $(elt).find('*').andSelf().unbind("tap click mouseup mousedown DOMMouseScroll mousewheel touchmove");
        return { controlsDescendantBindings: true };
    }
};*/
ko.bindingHandlers.disabled = {
    update: function (elt, va, bindings, model, context) {
        var disabled = ko.unwrap(va());
        if (disabled) {
            return ko.bindingHandlers.disable.update(elt, va, bindings, model, context);
        }
    }
};
$.fn.block_scroll = function (options) {
    var settings = $.extend({
        block_container: $("body"),
        container: $(".modal-content:visible"),
        unblock: "hide",
        block: "show",
        void_click_callback: function (event, container, $element) {},
        when: function (settings, event, container, $element) {
            return !($(settings.container).has(event.target).length > 0);
        }
    }, options);
    var kill_event = function (e) {
            console.debug("killing event: ", e);
            e.preventDefault();
            e.stopPropagation();
        },
        cleanup = function (c) {
            console.debug("restoring event: ", "DOMMouseScroll mousewheel mouseup mousedown touchmove", ", for container", c);
            c.off("DOMMouseScroll mousewheel touchmove");
            c.off("mouseup mousedown");
        };
    return this.each(function () {
        var $this = $(this);
        $this.on(settings.block, function (e) {
            console.debug("Event: ", settings.block, "for element", e.target);
            $(settings.block_container).off("DOMMouseScroll mousewheel touchmove").on("DOMMouseScroll mousewheel touchmove", function (e) {
                kill_event(e);
            });
            $(settings.block_container).off("mouseup mousedown").on("mouseup mousedown", function (e) {
                if (settings.when(settings, e, this, $this)) {
                    settings.void_click_callback(e, this, $this);
                    kill_event(e);
                }
            });
        }).bind(settings.unblock, function (e) {
            console.debug("Event: ", settings.unblock, "for element", e.target);
            cleanup($(settings.block_container));
        });
        $(settings.block_container).off("destroy").on("destroy", function (e) {
            cleanup($(settings.block_container));
        });
    });

};

ko.bindingHandlers.blockscroll = {
    "init": function (elt, va) {
        var opts = ko.unwrap(va());
        $(elt).block_scroll(opts);
    }
};

ko.bindingHandlers.popover = {
    "init": function (elt, va) {
        var content = ko.unwrap(va());
        var $elt = $(elt),
            popover = content.is_dom() ? content : $elt.next(".popover-element");
        $elt.block_scroll({
            container: ".popover",
            unblock: "hide.bs.popover",
            block: "show.bs.popover",
            void_click_callback: function (e, c, $elt) {
                $elt.popover("hide");
            },
            when: function (settings, e, container, element) {
                return !($(settings.container).has(e.target).length > 0) &&
                    (
                        !(e.target == elt) &&
                        !($elt.has(e.target).length > 0) &&
                        !$(e.target).closest(".select2-drop").length &&
                        $(e.target).attr("id") != "select2-drop-mask"
                    );
            }
        }).popover({
            placement: "bottom",
            container: "body",
            html: true,
            content: function () {
                return popover;
            }
        }).on("show.bs.popover", function (e) {
            popover.show();
        });

    }
};

ko.bindingHandlers.boundhtml = {
    init: function (elt, va, bindings, model, context) {
        return {
            "controlsDescendantBindings": true
        };
    },
    update: function (elt, va, bindings, model, context) {
        ko.virtualElements.emptyNode(elt);
        var markup = ko.unwrap(va()) || "";
        var _with = ko.unwrap(bindings().bindwith);
        var process_md_links = ko.unwrap(bindings().mdlinks);
        
        if (markup instanceof jQuery) {
            ko.virtualElements.prepend(elt, markup[0]);
        } else {
            if (process_md_links) {
                markup = markup.replace(/\[([^\]]+)\]\(([^)]*)\)/g, (link_text, link_type, link_val, offset, mk) => {
                    return ko.bindingHandlers.markdown.render_link(link_val, link_val, link_type);
                });
            }
            try {
                ko.virtualElements.setDomNodeChildren(elt, $.parseHTML(markup));
            } catch (err) {
                ko.virtualElements.prepend(elt, $("<span ></span>").html(markup)[0]);
            }
        }
        try {
            var new_allbindings = function () {
                return {
                    "with": bindings().bindwith
                };
            };
            new_allbindings.get = function(key) {
                if (key=="with") return bindings().bindwith;
                return null;
            }
            new_allbindings.has = function(key) {
                if (key=="with") return true;
                return false;
            }
            if (_with) {
                ko.bindingHandlers.with.init(
                    elt,
                    ko.observable(() => {
                        return bindings().bindwith;
                    }),
                    new_allbindings,
                    model, context);
                //ko.bindingHandlers.with.update(elt, function() { return bindings().bindwith; }, function() { return { "with": bindings().bindwith } }, model, context);
            } else {
                ko.applyBindingsToDescendants(context, elt);
            }
        } catch (e) {
            console.error("Error binding html:", e);
        }
    }
};
ko.virtualElements.allowedBindings.boundhtml = true;

var known_colour = [
    "aqua", "warning", "danger", "info", "primary", "success", "olive",
    "default", "jacksons-purple", "yellow-sea", "starship", "sienna", "maroon",
    "tomato", "bahia", "apple", "java", "light-sea-green", "vista-blue",
    "hippie-blue", "breaker-bay", "teal-blue", "plum", "spray", "blue",
    "teal"
];
var know_prefix = ["text", "bg", "box", "hr", "btn", "label"];




ko.bindingHandlers.label = {
    "update": function (elt, va, bindings, model, context) {
        var data = ko.unwrap(va());
        var $elt = $(elt);
        var as_button = ko.unwrap(bindings().as_button);
        var classes = ($elt.attr("class") || "").split(" ");
        var new_classes = [];
        var prefix = as_button ? "btn-" : "label-";
        $.each(classes, function (idx, val) {
            if (val && !val.indexOf(prefix) == 0)
                new_classes.push(val);
        });
        if (data.colour && data.colour != "") {
            if (known_colour.indexOf(data.colour) >= 0) {
                new_classes.push(prefix + data.colour);
                $elt.css("background-color", "auto");
            } else $(elt).css("background-color", data.colour);
        } else
            new_classes.push(prefix + "default");

        $(elt).attr("class", new_classes.join(" ")).addClass(as_button ? "btn btn-xs" : "label");
    }
};

ko.bindingHandlers.publish_event = {
    init: function (elt, va, bindings, model, context) {
        var binding_data = ko.unwrap(va());
        var payload = binding_data.payload;
        var event_mapping = ko.toJS(binding_data.events);
        var $elt = $(elt);
        $.each(event_mapping, function (dom_event, topic) {
            $elt.on(dom_event, function (ev, ui) {
                uly.publish(topic, ko.unwrap(payload));
            });
        });

    }
};


ko.bindingHandlers.colour = {
    get_colour_class_and_style: function (colour, prefix, current_classes) {
        var result = {
            "class": null,
            "style": null
        };
        var classes = (ko.unwrap(current_classes) || "").split(" ");

        var candidates = prefix ? $.map(known_colour, function (val) {
            return prefix + val;
        }) : known_colour;
        var new_classes = [];
        $.each(classes, function (idx, val) {
            if (val && !(candidates.indexOf(val) >= 0))
                new_classes.push(val);
        });
        colour = ko.unwrap(colour);
        if (colour && colour !== "") {
            if (known_colour.indexOf(colour) >= 0) {
                if (prefix)
                    new_classes.push(prefix + colour);
                else new_classes.push(colour);
                result.style = "auto";
            } else {
                result.style = colour;
            }
        }
        result["class"] = new_classes.join(" ");
        return result;
    },
    update: function (elt, va, bindings, model, context) {

        var colour = ko.unwrap(va());
        var prefix = ko.unwrap(bindings().class_prefix);
        var is_foreground = ko.unwrap(bindings().forecolour) || false;
        var style_prefix = ko.unwrap(bindings().style_prefix);
        if (!style_prefix) style_prefix = is_foreground ? "" : "background-";
        var style_attr = style_prefix + "color";
        var $elt = $(elt);
        if (!prefix && is_foreground)
            prefix = "text-";

        var css_data = ko.bindingHandlers.colour.get_colour_class_and_style(colour, prefix, $elt.attr("class") || "");
        if (typeof css_data.style !== "undefined")
            $elt.css(style_attr, css_data.style);
        $elt.removeClass().addClass(css_data["class"]);
    }
};
ko.virtualElements.allowedBindings.colour = true;
/** A simple binding to extend current context with a property
 *  should help us replace stupid root thing for controls
 */
ko.bindingHandlers.with_model = {
    init: function withModel_init(element, valueAccessor, allBindings, viewModel, bindingContext) {
        try {
            var model = ko.utils.unwrapObservable(valueAccessor());
            var cvm = ko.utils.unwrapObservable(allBindings().create_view_model) || false;
            //model = model;//cvm ? Crimson.view.createModel(model, null) : model;
            var context = bindingContext.extend(model);
            ko.applyBindingsToDescendants(context, element);
        } catch (e) {
            console.error(e);

        }
        return {
            "controlsDescendantBindings": true
        };
    }
};
ko.virtualElements.allowedBindings["with_model"] = true;
ko.bindingHandlers.nobinding = {
    init: function () {
        return {
            controlsDescendantBindings: true
        };
    }
};
ko.bindingHandlers.markdown = {
    render_link: function (href, title, linktype) {

        var linked = {
                facebook: "https://www.facebook.com/",
                "google-plus": "https://plus.google.com/u/0/",
                twitter: "https://twitter.com/",
                dropbox: "https://www.dropbox.com/s/",
                skype: "callto:",
                linkedin: "https://www.linkedin.com/"
            },
            contact = {
                phone: "tel:",
                mail: "mailto:",
                email: "mailto:"
            },
            exec = {
                action: "renderaction:"
            },
            external = [
                "website"
            ];
        if (linktype in linked) {
            if (href.indexOf("http") == -1) {
                var path = href.split("/");
                var last = path[path.length - 1];
                href = linked[linktype] + last;
            }
            return "<a class=\"btn btn-social-icon btn-" + linktype + "\" href=\"" + href + "\" target=\"_blank\" title=\"" + title + "\"><i class=\"fa fa-" + linktype + "\"></i></a>";
        } else if (linktype in contact) {
            return uly.utils.is_mobile() ? "<a class=\"\" href=\"" + contact[linktype] + href.replace(/[^\+0-9]/g, "") + "\" title=\"" + title + "\">" + href + "</a>" : href;
        } else if (linktype in exec) {
            return "<span data-bind=\"" + exec[linktype] + "\'" + href + "'\"></span>";
            //}else if($.inArray(text, external)!=-1){
            //return '<a class="" href="'+href+'" target="_blank" title="'+title+'">'+href+'</a>';
        } else {
            if (/^[a-zA-Z]+#[0-9a-f]{32}$/.test(href)) { 
                var items = href.split("#");
                href ="/" + items[0].toLowerCase() + "/" + items[1];
            }
            var out = "<a data-bind=\"action:'navigateto'\" data-link=\"" + href + "\"";
            if (title) {
                out += " title=\"" + (linktype ? linktype : title) + "\"";
            }
            if (linktype) {
                out += "><span>" + linktype + "</span></a>";
            } else {
                out += "><span>" + title + "</span></a>";

            }
            return out;
        }
    },
    renderer: new marked.Renderer(),
    init: function () {
        return {
            "controlsDescendantBindings": true
        };
    },
    update: function (elt, va, allbindings, model, context) {
        var value = ko.unwrap(va());
        var bind = ko.unwrap(allbindings().bind);
        value = marked.parse(value || "", {
            "renderer": ko.bindingHandlers.markdown.renderer
        });
        ko.cleanNode(elt);
        ko.utils.setHtml(elt, value);
        if (bind) {
            ko.applyBindingsToDescendants(context, elt);
        }
    }
};
ko.bindingHandlers.markdown.renderer.link = function (href, title, text) {
    if (this.options.sanitize) {
        try {
            var prot = decodeURIComponent(unescape(href))
                .replace(/[^\w:]/g, "")
                .toLowerCase();
        } catch (e) {
            return "";
        }
        if (prot.indexOf("javascript:") === 0) {
            return "";
        }
    }
    return ko.bindingHandlers.markdown.render_link(href, title, text);
};

ko.bindingHandlers.formathtml = {
    "init": function () {
        return {
            "controlsDescendantBindings": true
        };
    },
    "update": function (elt, va, allbindings) {
        var fields = ko.unwrap(va()) || [];
        var value = decodeURIComponent((ko.unwrap(allbindings().htmlformat) + "").replace(/\+/g, "%20"));
        value = value.replace(/&amp;quot;/g, '"').replace(/&amp;apos;/g, "'");
        var field_values = $.map(fields, function (a) {
            var val = ko.utils.unwrapObservable(a);
            if (val == null)
                val = "&nbsp;";
            else if (val.typeof("Date"))
                val = new moment(val).format("L LT");
            return val;
        });
        var result_text = (value || "").format(field_values);
        $(elt).html(result_text);
        $(elt).find("a").off("click tap").on("click tap", function (ev, ui) {
            var lk = $(ev.currentTarget || ev.target).attr("href");
            var target = $(ev.currentTarget || ev.target).attr("target");
            if (target == "_blank") {
                return;
            }
            if (lk && !(lk[0] == "#")) {
                console.log("going to:", lk);
                if (lk.indexOf("http") != 0 && lk.indexOf(".") > 1 && (lk.indexOf(".") < lk.indexOf("/") || lk.indexOf("/") < 0))
                    lk = "http://" + lk;
                uly.actions.navigateto(lk, $(this), ui);
                return false;
            }
        });
    }
};

ko.bindingHandlers.smarthtml = {
    init: ko.bindingHandlers.html.init,
    update: function (elt, va, allbindings, model, context) {
        ko.bindingHandlers.html.update(elt, va, allbindings, model, context);
        $(elt).find("a[href]").each(function () {
            var $a = $(this);
            if ($a.attr("target"))
                return;
            $a.on("click tap", function (ev, ui) {
                var href = $a.attr("href");
                if (href.indexOf("/download") == href.length - 9) {
                    //do the usual clicky stuff
                    return;
                }
                ev.preventDefault();
                uly.actions.navigateto(href);
            });
        });
    }
};

ko.bindingHandlers.link = {
    update: function (elt, va) {
        var link = uly.history.get_link(ko.unwrap(va()));
        $(elt).attr("href", link);
    }
};

ko.bindingHandlers.entitytemplate = {
    init: function (elt, va, allbindings, model, context) {
        $(elt).html("<!-- ko if: template_exists --><!-- ko template:template --><!-- /ko --><!-- /ko -->");
        var tmpl_obs = ko.pureComputed(function () {
            var entity_name = ko.unwrap(va());
            if (typeof entity_name == "undefined" || !entity_name)
                return null;

            if (Array.isArray(entity_name))
                entity_name = entity_name[entity_name.length - 1];
            if (typeof entity_name == "undefined" || !entity_name)
                return null;
            return "tmpl-" + entity_name.toLowerCase();
        });
        var child = {
            "template": tmpl_obs,
            "template_exists": ko.pureComputed(function () {
                var tmpl = ko.unwrap(tmpl_obs);
                if (!tmpl) {
                    return false;
                }
                var tmplElt = document.getElementById(tmpl);
                if (tmplElt) return true;
                return false;
            })
        };
        context = context.extend(child);
        ko.applyBindingsToDescendants(context, elt);
        return {
            "controlsDescendantBindings": true
        };
    }
};
ko.virtualElements.allowedBindings.entitytemplate = true;

ko.bindingHandlers.ulyif = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var result = ko.bindingHandlers["if"].init(element, valueAccessor, allBindings, viewModel, bindingContext);
        if (allBindings().trigger) {
            ko.computed(function () {
                var dataValue = ko.unwrap(valueAccessor());
                var trigger = allBindings().trigger;
                if (ko.isObservable(trigger))
                    trigger = ko.unwrap(trigger);
                if (typeof trigger == "function") {
                    trigger(element, dataValue);
                } else if (trigger) {
                    if (dataValue && trigger.onshow)
                        trigger.onshow(element, dataValue);
                    else if (!dataValue && trigger.onhide)
                        trigger.onhide(element, dataValue);
                }
            }, null, {
                disposeWhenNodeIsRemoved: element
            });
        }
        return result;
    }
};

ko.bindingHandlers.ulyifnot = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var result = ko.bindingHandlers.ifnot.init(element, valueAccessor, allBindings, viewModel, bindingContext);
        if (allBindings().trigger) {
            ko.computed(function () {
                var dataValue = ko.unwrap(valueAccessor());
                var trigger = allBindings().trigger;
                if (ko.isObservable(trigger))
                    trigger = ko.unwrap(trigger);
                if (typeof trigger == "function") {
                    trigger(element, dataValue);
                } else if (trigger) {
                    if (!dataValue && trigger.onshow)
                        trigger.onshow(element, dataValue);
                    else if (dataValue && trigger.onhide)
                        trigger.onhide(element, dataValue);
                }
            }, null, {
                disposeWhenNodeIsRemoved: element
            });
        }
        return result;
    }
};
ko.virtualElements.allowedBindings.ulyif = true;
ko.virtualElements.allowedBindings.ulyifnot = true;

ko.bindingHandlers.toggle = {
    init: function (element, va, allbindings, viewmodel, bindingcontext) {
        var value_obs = va();
        var clicky = function () {
            return function () {
                value_obs(!value_obs());
            };
        };
        return ko.bindingHandlers.click.init(element, clicky, allbindings, viewmodel, bindingcontext);
    }
};

ko.bindingHandlers.iframe = {
    update: function (elt, va, allbindings) {
        var old_url = $(elt).attr("src");
        var new_url = ko.unwrap(va());
        var params = false;
        if (ko.unwrap(allbindings().params_from_url)) {
            var paramkey = ko.unwrap(allbindings().paramkey);
            var state = uly.history.get_parsed_state();
            var query_data = state.query_data;
            if (paramkey) {
                var params = {};
                $.each(query_data, function (key, val) {
                    if (key == paramkey)
                        params = val;
                    else if (key.indexOf(paramkey + ".") == 0)
                        params[key.slice(paramkey.length + 1)] = val;
                });
            } else params = query_data;
            if (params) {
                var uri = new URI(new_url);
                console.log("got uri:", uri);
                uri.addQuery(params);
                new_url = uri.toString();
            }

        }
        $(elt).attr("src", new_url);
    }
};

ko.bindingHandlers.refreshtabs = {
    "update": function (elt, va, allbindings, model, context) {
        setTimeout(function () {
            var $tab = $(elt).closest(".nav-tabs-custom");
            var $active_tab = $tab.children("ul > li.active");
            if ($active_tab.length === 0) {
                $tab.find("li:first a").tab("show");
            }
        }, 0);
    }
};
ko.virtualElements.allowedBindings.refreshtabs = true;

// Here's a custom Knockout binding that makes elements shown/hidden via jQuery's fadeIn()/fadeOut() methods
// Could be stored in a separate utility library
ko.bindingHandlers.fadeVisible = {
    init: function (element, valueAccessor) {
        // Initially set the element to be hidden
        var value = valueAccessor();
        $(element).hide(); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    update: function (element, valueAccessor) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
    }
};

function apply_field_value(field, value, model) {
    if (!field) {
        return;
    }
    if (typeof value === "undefined") {
        return;
    }
    console.log("afv: ", field, " <-- ", value);
    var toks = field.split(".");
    var last_tok = toks[toks.length - 1];
    var is_conditional = last_tok && last_tok.startsWith("?");
    var current = model;
    var previous = null;
    toks.forEach(function (tok) {
        previous = current;
        if (tok.startsWith("?")) {
            tok = tok.slice(1);
        }
        if (current)
            current = ko.unwrap(current)[tok];
    });
    if (current && ko.isObservable(current)) {
        if (is_conditional) {
            var old_val = current();
            if (!old_val || old_val == "") {
                current(value);
            }
        } else {
            current(value);
        }
    } else {
        if (current && Object.isObject(current)) {
            if (Object.isObject(value)) {
                $.each(value, function (key, value) {
                    apply_field_value(key, value, current);
                });
            } else if (value) {
                if (previous) {
                    previous[toks[-1]] = value;
                }
            } else {
                //we have a false-y value for an object.
                //not sure what to do.
            }
        } else {
            if (previous) {
                if (last_tok && last_tok.startsWith("?")) last_tok = last_tok.slice(1);
                if (!is_conditional || !previous[last_tok]) {
                    previous[last_tok] = value;
                }
            }
        }
    }
}
ko.bindingHandlers.fetcher = {
    update: function (elt, va, allbindings, model) {

        var fetcher = ko.unwrap(va());
        var previous = fetcher.trigger._old_value;

        var trigger = ko.unwrap(fetcher.trigger);
        fetcher.trigger._old_value = trigger;

        var initialised = $(elt).data("fetcher_inited");
        if (!initialised) {
            $(elt).data("fetcher_inited", true);
            if (!ko.unwrap(allbindings().trigger_on_init)) {
                return;
            }
        }
        if (!trigger) {
            if (typeof previous != "undefined" && previous) {
                $.each(ko.unwrap(fetcher.field_map), (key, value) => {
                    apply_field_value(key, null, model);
                });
            }
            var res = Promise.Deferred();
            res.resolve(null);
            return res;
        }
        uly.api.start().follow("uly:data").then(function (data) {
            var map = ko.unwrap(fetcher.field_map);
            return HalResource(data)
                .follow("uly:" + ko.unwrap(fetcher.entity), {
                    "nodata": 1
                })
                .follow("find", {
                    "rel": ko.unwrap(trigger),
                    "fields": $.map(map, function (v, k) {
                        return v;
                    })
                });
        }).then(function (entity) {
            var map = ko.unwrap(fetcher.field_map);
            $.each(map, function (key, value) {
                console.log("fetcher: ", key, " <-- ", value, ": ", entity[value]);
                apply_field_value(key, entity === null || trigger === null ? null : entity[value], model);
            });
        }).fail(function (error) {
            console.error("Fetcher failed:", error);
        });
    }
};

ko.virtualElements.allowedBindings.fetcher = true;
ko.bindingHandlers.clientscript = {
    update: function (elt, va, allbindings, model) {
        //simply execute the code
        ko.unwrap(va());
    }
};
ko.virtualElements.allowedBindings.clientscript = true;

ko.bindingHandlers.rangeforeach = {
    update: function (elt, va, allbindings, model, context) {
        var count_obs = va();
        var obs = model;
        var data_obs = allbindings().datafield;
        var delta = (ko.unwrap(count_obs) || 0) - (ko.unwrap(data_obs) || []).length;
        if (delta > 0) {
            var data = ko.unwrap(data_obs);
            if (!data)
                data = [];
            for (var i = 0; i < delta; ++i) {
                data.push({
                    "clist": ko.observable(null)
                });
            }
            data_obs(data);
        } else if (delta < 0) {
            data_obs.splice(delta);
        }
    }
};

ko.virtualElements.allowedBindings.rangeforeach = true;
window.URI = URI;

ko.bindingHandlers.nicedate = {
    update: function (elt, va) {
        var dt = ko.unwrap(va());
        if (!dt) {
            $(elt).text("");
        } else {
            var dt = new moment(dt);
            $(elt).text(dt.format("LL LT")); //dt.fromNow());
        }
    }
};

ko.bindingHandlers.strippedhtml = {
    update: function (elt, va, bindings, model, context) {
        var html = ko.unwrap(va());
        var $div = $("<div />");
        $div.html(html);
        return ko.bindingHandlers.text.update(elt, function () {
            return $div.text();
        }, bindings, model, context);
    }
};

ko.bindingHandlers.stopBubble = {
    init: function (elt, va) {
        ko.utils.registerEventHandler(elt, ko.unwrap(va()) || "click", function (event) {
            event.cancelBubble = true;
            if (event.stopPropagation) {
                event.stopPropagation();
            }
        });
    }
};

ko.bindingHandlers.formattedattr = {
    "update": function (elt, va, allbindings) {
        var value = ko.unwrap(va()) || {};
        var fields = ko.unwrap(allbindings().fields) || [];

        var field_values = $.map(fields, function (a) {
            return ko.unwrap(a);
        });
        for (var attrName in value) {
            if (typeof attrName == "string") {
                var attrValue = ko.unwrap(value[attrName]);
                if (typeof attrValue != "undefined" && attrValue != null) {
                    attrValue = attrValue.format(field_values);
                }
                // To cover cases like "attr: { checked:someProp }", we want to remove the attribute entirely
                // when someProp is a "no value"-like value (strictly null, false, or undefined)
                // (because the absence of the "checked" attr is how to mark an element as not checked, etc.)
                if ((attrValue === false) || (attrValue === null) || (attrValue === undefined))
                    elt.removeAttribute(attrName);
                else
                    elt.setAttribute(attrName, attrValue.toString());
            }
        }
    }
};

ko.bindingHandlers.formatdate = {
    "init": function () {},
    "update": function (elt, va, allbindings) {
        var dt = ko.unwrap(va());
        var format = ko.unwrap(allbindings().format)
        var title_format = ko.unwrap(allbindings().title_format);
        var icon = ko.unwrap(allbindings().dateicon);
        if (!dt || dt === "") {
            $(elt).text("");
            $(elt).attr("title", "");
        } else {
            var dt = new moment(dt).format("L");
            var text = dt;
            if (format) {
                text = format.format(dt);
            }
            if (icon) text = '<i class="fa ' + icon + '"></i> ' + text;
            var title = dt;
            if (title_format) {
                title = title_format.format(dt);
            }
            $(elt).html(text);
            $(elt).attr("title", title);
        }
    }
};

ko.bindingHandlers.formatdatetime = {
    "init": function () {},
    "update": function (elt, va, allbindings) {
        var dt = ko.unwrap(va());
        var format = ko.unwrap(allbindings().format)
        var title_format = ko.unwrap(allbindings().title_format);
        var icon = ko.unwrap(allbindings().dateicon);
        if (!dt || dt === "") {
            $(elt).text("");
            $(elt).attr("title", "");
        } else {
            var dt = new moment(dt).format("L LT");
            var text = dt;
            if (format) {
                text = format.format(dt);
            }
            if (icon) text = '<i class="fa ' + icon + '"></i> ' + text;
            var title = dt;
            if (title_format) {
                title = title_format.format(dt);
            }
            $(elt).html(text);
            $(elt).attr("title", title);
        }
    }
};

ko.bindingHandlers.collapsibleBox = {
    init: function (elt) {
        if ($.fn.boxWidget) {
            $(elt).boxWidget();
        } else if ($.fn.CardWidget) {
            $(elt).CardWidget("collapse");
        }
    }
};
